module.exports = "<p>\n  close-session works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/close-session/close-session.component.html
// module id = ../../../../../src/app/pages/admin/close-session/close-session.component.html
// module chunks = main